/**
 * The form of a noun that agrees with a count.
 *
 * Both forms are given rather than derived by appending an `s`: "activity"
 * does not pluralise that way, and the rule would have to be unlearned the
 * first time it met one that does not. Zero takes the plural, as English
 * does - "0 activities", not "0 activity".
 *
 * Returns the noun alone rather than the whole phrase, because an adjective
 * often sits between the two: "1 free activity".
 */
export const plural = (count: number, one: string, many: string): string =>
  count === 1 ? one : many;
